"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTempFilterContext = exports.convertFilterContext = exports.convertFilterContextItem = exports.sanitizeExportFilterContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
function isNotTemporaryAllTimeDateFilter(filter) {
    if (sdk_backend_spi_1.isDashboardDateFilter(filter)) {
        return filter.dateFilter.from !== undefined || filter.dateFilter.to !== undefined;
    }
    return true;
}
// Remove the temporary "All Time" date filter from filter context when exporting the dashboard
exports.sanitizeExportFilterContext = function (exportFilterContext) {
    return tslib_1.__assign(tslib_1.__assign({}, exportFilterContext), { filters: exportFilterContext.filters.filter(isNotTemporaryAllTimeDateFilter) });
};
exports.convertFilterContextItem = function (filterContextItem) {
    if (api_model_bear_1.GdcFilterContext.isAttributeFilter(filterContextItem)) {
        var _a = filterContextItem.attributeFilter, attributeElements = _a.attributeElements, displayForm = _a.displayForm, negativeSelection = _a.negativeSelection, localIdentifier = _a.localIdentifier, _b = _a.filterElementsBy, filterElementsBy = _b === void 0 ? [] : _b;
        var convertedFilterElementsBy = filterElementsBy.map(function (filterBy) {
            return {
                filterLocalIdentifier: filterBy.filterLocalIdentifier,
                over: {
                    attributes: filterBy.over.attributes.map(sdk_model_1.uriRef),
                },
            };
        });
        return {
            attributeFilter: {
                attributeElements: { uris: attributeElements },
                displayForm: sdk_model_1.uriRef(displayForm),
                negativeSelection: negativeSelection,
                localIdentifier: localIdentifier,
                filterElementsBy: convertedFilterElementsBy,
            },
        };
    }
    var _c = filterContextItem.dateFilter, granularity = _c.granularity, type = _c.type, attribute = _c.attribute, dataSet = _c.dataSet, from = _c.from, to = _c.to;
    var convertedFilterContextItem = {
        dateFilter: {
            granularity: granularity,
            type: type,
            from: from,
            to: to,
        },
    };
    if (attribute) {
        convertedFilterContextItem.dateFilter.attribute = sdk_model_1.uriRef(attribute);
    }
    if (dataSet) {
        convertedFilterContextItem.dateFilter.dataSet = sdk_model_1.uriRef(dataSet);
    }
    return convertedFilterContextItem;
};
exports.convertFilterContext = function (filterContext) {
    var _a = filterContext.filterContext, filters = _a.content.filters, _b = _a.meta, identifier = _b.identifier, uri = _b.uri, summary = _b.summary, title = _b.title;
    return tslib_1.__assign(tslib_1.__assign({ description: summary }, (uri
        ? {
            identifier: identifier,
            uri: uri,
            ref: sdk_model_1.uriRef(uri),
        }
        : {})), { title: title, filters: filters.map(exports.convertFilterContextItem) });
};
exports.convertTempFilterContext = function (filterContext) {
    var _a = filterContext.tempFilterContext, created = _a.created, filters = _a.filters, uri = _a.uri;
    return {
        uri: uri,
        ref: sdk_model_1.uriRef(uri),
        filters: filters.map(exports.convertFilterContextItem),
        created: created,
    };
};
//# sourceMappingURL=filterContext.js.map